<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0 px-0">
          <b-tabs class="gridtabs" v-model="tabIndex">
            <b-tab active>
              <template #title>
                <i :class="forecasts.icon" class="text-primary mr-1"></i>
                {{ item.yourref }}
                <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
              </template>
              <p class="pb-3 px-0">
                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    General
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group :label="$helpers.requiredlabel(
                      requirement,
                      'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                    )
                      " :class="$helpers
                        .requiredlabel(
                          requirement,
                          'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                        )
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm" label-cols="12">
                      <!-- label="Your Ref / PO (incl. Requistion No's e.g. A,B,C)"
                    label-for="yourref" -->
                      <b-form-textarea id="data" v-model="item.yourref" placeholder="Your Ref" rows="2"
                        class="smalltextarea" trim></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group label="Description (Leave empty for Event Name)" label-for="description"
                      label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.description" placeholder="Description" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.description = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Event" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:34px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="eventcode"></i>
                      </b-input-group>
                      <b-tooltip target="eventcode" triggers="hover" placement="top">Enter an eventcode to set the
                        description as
                        event name, alternatively add a description.</b-tooltip>
                      <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                        v-model="item.eventcode" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :multiple="true">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Client SL A/C')
                      " :class="$helpers
                        .requiredlabel(requirement, 'Client SL A/C')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly" :multiple="true">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Placed At" label-size="sm">
                      <b-input-group>
                        <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="mapper_placed_at"
                          :disabled="readonly" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                            direction: 'ltr',
                            format: 'dd/mm/yyyy HH:MM',
                            daysOfWeek: [
                              'Sun',
                              'Mon',
                              'Tue',
                              'Wed',
                              'Thu',
                              'Fri',
                              'Sat',
                            ],
                            monthNames: [
                              'January',
                              'February',
                              'March',
                              'April',
                              'May',
                              'June',
                              'July',
                              'August',
                              'September',
                              'October',
                              'November',
                              'December',
                            ],
                            firstDay: 1,
                            applyLabel: 'OK',
                            cancelLabel: 'Cancel',
                          }" :showDropdowns="true" :ranges="false" :linkedCalendars="true" :timePicker="true"
                          :timePicker24Hour="true" :time-picker-increment="1">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="mapper_placed_at = {
                            startDate: null,
                            endDate: null,
                          }">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Value GBP (Ex VAT)" label-for="valueexvat" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:98px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="valueexvat"></i>
                      </b-input-group>
                      <b-tooltip target="valueexvat" triggers="hover" placement="top">Enter the total value GBP of the
                        order excluding
                        VAT. (optional)</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.valueexvat" placeholder="Value GBP (Ex VAT)"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.valueexvat = '0.00'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="VAT" label-for="valuevat" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:25px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="vat"></i>
                      </b-input-group>
                      <b-tooltip target="vat" triggers="hover" placement="top">Enter the VAT GBP value of the order.
                        (optional)</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.valuevat" placeholder="VAT" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.valuevat = '0.00'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Value GBP" label-for="total" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:56px; top:-12px">
                        <i class="fa fa-info-circle text-danger" id="valuegbp"></i>
                      </b-input-group>
                      <b-tooltip target="valuegbp" triggers="hover" placement="top">Enter the total value GBP of the
                        order including
                        VAT. (mandatory)</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.value" :state="false" placeholder="Value GBP"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.value = '0.00'">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Spent GBP" label-for="total" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:62px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="spentgbp"></i>
                      </b-input-group>
                      <b-tooltip target="spentgbp" triggers="hover" placement="top">This is the accumulated spend GBP by
                        summing
                        transactions against this order. (calculated)</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.spent" placeholder="Spent GBP" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.spent = ''" :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Reclaim VAT GBP" label-for="total" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:90px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="reclaimgbp"></i>
                      </b-input-group>
                      <b-tooltip target="reclaimgbp" triggers="hover" placement="top">This is the potential accumulated reclaim VAT GBP by
                        summing
                        eligable transactions against this order. (calculated)</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.reclaim" placeholder="Spent GBP" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.reclaim = ''" :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Show Forecast?" label-for="forecast_on" label-cols="12">
                      <b-input-group class="z-0">
                        <b-form-radio-group id="forecast_on" :disabled="readonly" v-model="item.forecast_on" :options="[
                          { text: 'Yes', value: true },
                          { text: 'No', value: false },
                        ]" buttons button-variant="outline-success" size="sm"
                          name="radio-btn-outline"></b-form-radio-group>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->


                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Required At" label-size="sm">
                      <b-input-group>
                        <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="mapper_required_at"
                          :disabled="readonly" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                            direction: 'ltr',
                            format: 'dd/mm/yyyy',
                            daysOfWeek: [
                              'Sun',
                              'Mon',
                              'Tue',
                              'Wed',
                              'Thu',
                              'Fri',
                              'Sat',
                            ],
                            monthNames: [
                              'January',
                              'February',
                              'March',
                              'April',
                              'May',
                              'June',
                              'July',
                              'August',
                              'September',
                              'October',
                              'November',
                              'December',
                            ],
                            firstDay: 1,
                            applyLabel: 'OK',
                            cancelLabel: 'Cancel',
                          }" :showDropdowns="true" :ranges="false" :linkedCalendars="true" :timePicker="false"
                          :timePicker24Hour="false" :time-picker-increment="1">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.mapper_required_at = {
                            startDate: null,
                            endDate: null,
                          }">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Expiry At" label-size="sm">
                      <b-input-group>
                        <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="mapper_expiry_at"
                          :disabled="readonly" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                            direction: 'ltr',
                            format: 'dd/mm/yyyy',
                            daysOfWeek: [
                              'Sun',
                              'Mon',
                              'Tue',
                              'Wed',
                              'Thu',
                              'Fri',
                              'Sat',
                            ],
                            monthNames: [
                              'January',
                              'February',
                              'March',
                              'April',
                              'May',
                              'June',
                              'July',
                              'August',
                              'September',
                              'October',
                              'November',
                              'December',
                            ],
                            firstDay: 1,
                            applyLabel: 'OK',
                            cancelLabel: 'Cancel',
                          }" :showDropdowns="true" :ranges="false" :linkedCalendars="true" :timePicker="false"
                          :timePicker24Hour="false" :time-picker-increment="1">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.mapper_expiry_at = {
                            startDate: null,
                            endDate: null,
                          }">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Agent" label-for="agent" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.agent" placeholder="Agent" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Deposit Refs ( Paste List )" label-for="depositref" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:128px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="depositref"></i>
                      </b-input-group>
                      <b-tooltip target="depositref" triggers="hover" placement="top">List the transactions you wish to
                        be excluded
                        from the sum of costs (e.g. a deposit payment)</b-tooltip>
                      <b-input-group>

                        <b-form-tags input-id="reflist1" v-model="item.depositref" tag-variant="primary" separator=" ,;"
                          placeholder="Paste Deposit Ref (IA..,IA...)" size="sm" class="h-29" add-button-text="+"
                          add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.depositref = []">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Manager" label-for="manager" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.manager" placeholder="Manager" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.manager = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Pay By" label-size="sm">
                      <treeselect placeholder="Select pay by..." v-model="item.payby" :clearable="true"
                        :options="payby_options" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col> -->
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Margin By" label-size="sm">
                      <treeselect placeholder="Select margin by..." v-model="item.marginby" :clearable="true"
                        :options="marginby_options" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Margin Value" label-for="margin" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.margin" placeholder="Margin" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.margin = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>


                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Contact" label-for="contact" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.contact" placeholder="Contact" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.contact = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Contract" label-for="contract" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.contract" placeholder="Contract"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.contract = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Reason ?" label-for="reason" label-cols="12" label-size="sm">
                      <treeselect v-model="item.reason" :clearable="true" :options="reasoncode_options"></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <treeselect placeholder="Select status..." v-model="item.status" :clearable="true"
                        :options="status_options" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                </b-row>
                <!-- <b-row>
                  <b-col cols="12" sm="12">
                    <b-form-group
                      label="Notes"
                      label-for="notes"
                      label-cols="12"
                    >
                      <b-form-textarea
                        id="notes"
                        v-model="item.notes"
                        placeholder="Notes"
                        :disabled="readonly"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    Attachment
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group label="Click x to remove or browse for document upload..." label-size="sm">
                      <b-input-group class="treeselect_all" style="left:265px; top:4px">
                        <i class="fa fa-info-circle text-black" id="fileUpload"></i>
                      </b-input-group>
                      <b-tooltip target="fileUpload" triggers="hover" placement="top">Upload an attachment document
                        (.pdf,.docx,.xlsx
                        or .zip) other document confirming this order. (optional)</b-tooltip>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button size="sm" title="delete" variant="outline-danger" @click="fileUpload_clear">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-prepend>
                        <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input" :multiple="false"
                          no-drop @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                            " :disabled="fileUpload ? true : false"></b-form-file>
                        <b-input-group-append>
                          <b-button class="ml-1" size="sm" title="view file" variant="outline-primary"
                            @click="fileUpload_view" :disabled="!fileUpload">
                            <i class="fa fa-download"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    Notifications
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="3">
                    <b-form-group label="Notify Limit %" label-for="notify_limit" label-cols="12">

                      <b-input-group class="treeselect_all" style="left:75px; top:-12px">
                        <i class="fa fa-info-circle text-black z-1" id="notify_limit"></i>
                      </b-input-group>

                      <b-tooltip target="notify_limit" triggers="hover" placement="top">When the used % reaches
                        the notify limit % a daily email notfication will sent.
                      </b-tooltip>

                      <b-input-group class="treeselect_all justify-content-end" style="padding-right:40px;">
                        <span>Used: <span class="ml-1 text-danger">{{ used }}</span>%</span>
                      </b-input-group>

                      <b-input-group>
                        <b-form-input type="text" v-model="item.notify_limit" placeholder="Notify Limit %"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.notify_limit = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group label="Notify Email" label-for="notify_email" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:65px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="notify_email"></i>
                      </b-input-group>
                      <b-tooltip target="notify_email" triggers="hover" placement="top">Enter email addresses here,
                        separated by
                        commas, for all the people you wish to notify the order about.</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.notify_email" placeholder="Notify Email"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.notify_email = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Spend Manager Checked" label-size="sm" :disabled="true">
                      <b-input-group class="treeselect_all" style="left:130px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="notify_checked"></i>
                      </b-input-group>
                      <b-tooltip target="notify_checked" triggers="hover" placement="top">The date and time the spend
                        manager last ran.</b-tooltip>
                      <b-input-group>
                        <b-form-input :value="item.notify_at
                          ? this.$helpers.datetimefield(item.notify_at)
                          : null
                          " :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.notify_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="3">
                    <b-form-group label="Notify Checked" label-for="notify_checked" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:80px; top:-12px">
                        <i class="fa fa-info-circle text-black" id="notify_checked"></i>
                      </b-input-group>
                      <b-tooltip target="notify_checked" triggers="hover" placement="top">notify_checked</b-tooltip>
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.notify_df" button-only label-help="" locale="en-GB"
                            hide-header :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.notify_df" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="true"
                            @click="item.notify_df = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                </b-row>

              </p>
            </b-tab>

            <!-- <b-tab v-if="item.forecast_on">
              <template #title>
                <i class="fa fa-line-chart text-primary mr-1"></i> Forecast
              </template>
              <b-alert :show="forecasts.incomplete" variant="danger" class="mt-2">
                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                    <i class="fa fa-info-circle fa-2x"></i></b-col>
                  <b-col>One or more of the outlook forecasts has a zero value. This
                    can be normal whilst the event is in the planning stage or
                    has been completely invoiced. Please return frequently for
                    updates.</b-col></b-row>
              </b-alert>
              <b-alert :show="forecasts.overlap" variant="warning" class="mt-2">
                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                    <i class="fa fa-info-circle fa-2x"></i></b-col>
                  <b-col>We have detected more than one forecast with the same
                    routing and an empty or overlapping date range. Please
                    correct the highlighted data below to avoid double
                    accounting.</b-col></b-row>
              </b-alert>

              <e-table id="forecasts" v-if="!forecasts.component" class="etable" :icon="'fa fa-line-chart text-primary'"
                :refid="'forecasts'" :busy="forecasts.busy" :tools="forecasts.tools" :fields="forecasts.fields"
                :items="forecasts.items" :showpages="false" :showautoadd="false" @click="forecasts_click"
                @select="forecasts_select" @change="forecasts_update" />

              <div v-if="forecasts.component">
                <component :is="forecasts.component" :selection="forecasts.selected" :config="cconfig"
                  @discard="forecasts_toolClick('discard')" @refresh="forecasts_toolClick('refresh')"></component>
              </div>
            </b-tab> -->

            <!-- <b-tab v-if="this.user.permissions.includes('orders.accounting')">
              <template #title>
                <i class="fa fa-gbp text-primary mr-1"></i> Accounting
              </template>
              <b-alert show variant="danger" class="mt-2" v-if="item.value == '0.00'">
                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                    <i class="fa fa-info-circle fa-2x"></i></b-col>
                  <b-col>This order has no financial value, therefore it will never
                    reach any limit to send notifications.</b-col></b-row>
              </b-alert>
              <p class="py-3 px-0">
           
              </p>
            </b-tab> -->

            <b-tab>
              <template #title>
                <i class="fa fa-comments-o text-primary mr-1"></i>
                Notes</template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Notes" label-for="notes" label-cols="12">
                      <b-form-textarea id="data" v-model="item.notes" placeholder="Notes" rows="6" class="smalltextarea"
                        :disabled="!permissionvalid('orders.save')"></b-form-textarea>
                    </b-form-group> </b-col></b-row>
                <b-row>
                  <b-col>
                    <b-button squared size="sm" variant="outline-primary" class="mr-1" @click="timestamp">
                      <i class="fa fa-clock-o"></i>
                      Add a timestamp
                    </b-button>
                  </b-col>
                </b-row>

              </p>
            </b-tab>


            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="ID" label-for="id" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                          :disabled="true"></b-form-input>

                      </b-input-group>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
          </b-tabs>
        </b-card-body>

        <b-card-footer v-if="!forecasts.component" class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit"
                v-if="user.permissions.includes('orders.save')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="$emit('discard')">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>

        <!-- 
        <b-card-footer v-if="!forecasts.component" class="mt-2 ml-1">
          <b-row>
            <b-col class="text-left">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="3" >
              <b-button
                squared
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
              <b-button
                squared
                size="sm"
                variant="primary"
                @click="saveit()"
                v-if="user.permissions.includes('orders.save')"
              >
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            v-if="tabIndex != 1" 
          </b-row>
        </b-card-footer> -->
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

import OrdersForecastsNotes from "./OrdersForecastsNotes";

export default {
  name: "OrdersEdit",
  components: {
    OrdersForecastsNotes,
  },
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      tabIndex: 0,
      readonly: false,

      used: 0,
      mapper_placed_at: {
        startDate: this.$moment().format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD'),
      },
      mapper_required_at: {
        startDate: null,
        endDate: null,
      },
      mapper_expiry_at: {
        startDate: null,
        endDate: null,
      },
      requirement: {
        slac: "Client SL A/C",
        // yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
      },
      item: {
        id: null,
        slac: [],
        eventcode: [],
        depositref: [],
        notes: null,
        status: "1",
        agent: null,
        forecast_on: false,
      },
      items: [],
      payby_options: [{ id: "IN", label: "Invoice" }],
      marginby_options: [
        { id: "COM", label: "Commission" },
        { id: "FEE", label: "Fee" },
      ],
      status_options: [
        { id: "0", label: "Complete" },
        { id: "1", label: "Active" },
        { id: "2", label: "Cancelled" },
      ],
      reasoncode_options: [],

      // options: {
      //   title: "Order Booking Edit",
      //   icon_header: "fa fa-gavel",
      //   icon: "fa fa-gavel",

      // },
      forecasts: {
        busy: false,
        component: null,
        debounce: 500,
        icon: "fa fa-gavel",
        tools: "back,save,refresh,export,notes,deleteconfirm",
        fields: [
          {
            key: "routing",
            label: "Routing",
            type: "text",
            placeholder: "Routing (AAA/BBB) or * for all",
            class: "text-right w-40pct",
            clearable: "true",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-40pct",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "value",
            label: "Value",
            type: "text",
            class: "text-right w-40pct",
            disabled: "true",
          },
        ],
        items: [],
        selected: [],
        incomplete: false,
        overlap: false,
      },
    };
  },
  watch: {
    mapper_placed_at: {
      async handler(newVal, oldVal) {
        if (newVal.startDate) {
          this.item.placed_at = this.$moment(newVal.startDate).valueOf().toString()
        } else {
          this.item.placed_at = ''
        }
      }
    },
    mapper_required_at: {
      async handler(newVal, oldVal) {
        if (newVal.startDate) {
          this.item.required_at = this.$moment(newVal.startDate).valueOf().toString()
        } else {
          this.item.required_at = ''
        }
      }
    },

    mapper_expiry_at: {
      async handler(newVal, oldVal) {
        if (newVal.startDate) {
          this.item.expiry_at = this.$moment(newVal.startDate).valueOf().toString()
        } else {
          this.item.expiry_at = ''
        }
      }
    },

    fileUpload: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:fileUpload", newVal);
        }
      },
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders($id: String) {
              orders(id: $id) {
                id
                description
                yourref
                placed_at
                required_at
                expiry_at
                status
                agent
                eventcode
                slac
                notes
                valueexvat
                valuevat
                value
                spent
                reclaim
                reason
                contact
                contract
                manager
                notify_email
                notify_limit
                notify_at
                payby
                depositref
                marginby
                margin
                to
                forecast_on
                data
                created_at
                created_by
                updated_at
                updated_by
                # forecasts {
                #   id
                #   line
                #   routing
                #   datetravel
                #   value
                # }
              }
            }
          `,
          variables,
        });

        if (response.data.orders.length > 0) {
          this.item = response.data.orders[0];

          if (parseFloat(this.item.spent) > 0 && parseFloat(this.item.value) > 0) {
            this.used = ((parseFloat(this.item.spent) / parseFloat(this.item.value)) * 100).toFixed(2)
          }

          if (this.item.placed_at) {
            let v = this.$moment.unix(this.item.placed_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
            this.mapper_placed_at = { startDate: v, endDate: v }
          }
          if (this.item.required_at) {
            let v = this.$moment.unix(this.item.required_at * 0.001).utc(false).format("YYYY-MM-DD")
            this.mapper_required_at = { startDate: v, endDate: v }
          }
          if (this.item.expiry_at) {
            let v = this.$moment.unix(this.item.expiry_at * 0.001).utc(false).format("YYYY-MM-DD")
            this.mapper_expiry_at = { startDate: v, endDate: v }
          }

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
          this.item.eventcode = this.item.eventcode
            ? this.item.eventcode.split(",")
            : [];
          this.item.depositref = this.item.depositref ? this.item.depositref.split(",") : [];

          if (this.item.data) {
            try {
              this.fileUpload = JSON.parse(this.item.data);
            } catch (error) {
              this.fileUpload = {
                name: this.item.yourref + ".pdf",
                data: this.item.data,
              };
            }
          }

          // this.forecasts.incomplete = false;
          // for (var j = 0; j < this.item.forecasts.length; ++j) {
          //   let routes = this.item.forecasts.filter(
          //     (o) => o.routing == this.item.forecasts[j].routing
          //   );

          //   if (routes.length > 1) {
          //     let mind = "2100-12-31";
          //     let maxd = this.$moment().format("YYYY-MM-DD");
          //     for (var k = 0; k < routes.length; ++k) {
          //       routes[k].rowClass = "overlap";
          //     }
          //     // for (var k = 0; k < routes.length; ++k) {
          //     //   let item = routes[k];
          //     //   console.log(item.datetravel)
          //     //   if (item.datetravel) {
          //     //     if (item.datetravel.startDate) {
          //     //       console.log(this.$moment(item.datetravel.startDate))
          //     //       if (this.$moment(item.datetravel.startDate).toDate() > this.$moment(mind).toDate()) {
          //     //         mind = this.$moment(item.datetravel.startDate).toDate();
          //     //       }
          //     //     }
          //     //     if (item.datetravel.endDate) {
          //     //        console.log(this.$moment(item.datetravel.endDate))
          //     //       if (this.$moment(item.datetravel.endDate).toDate() < this.$moment(maxd).toDate()) {
          //     //         maxd = this.$moment(item.datetravel.endDate).toDate();
          //     //       }
          //     //     }
          //     //   }
          //     // }
          //     // console.log(mind, maxd);
          //     this.forecasts.overlap = true;
          //   }

          //   if (this.item.forecasts[j].value == 0) {
          //     this.forecasts.incomplete = true;
          //   }
          // }
          // this.forecasts.items = [...this.item.forecasts];
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_ordersreasons {
              setup_ordersreasons {
                id
                label
                type
              }
            }
          `,
        });
        this.reasoncode_options = response.data.setup_ordersreasons;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let row = this.cleanit(this.item);

      row.slac = row.slac.length > 0 ? row.slac.join(",") : null;
      row.eventcode = row.eventcode.length > 0 ? row.eventcode.join(",") : null;
      row.depositref = row.depositref.length > 0 ? row.depositref.join(",") : null;

      console.log(row);
      this.message = this.$helpers.mandatoryFields(
        {
          slac: "Client SL A/C",
          // yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
        },
        row
      );
      if (this.message.length > 0) {
        return;
      }

      this.busy = true;

      let variables = { rows: [row] };

      if (this.fileUpload) {
        variables.rows[0].data = JSON.stringify(this.fileUpload);
      } else {
        variables.rows[0].data = "";
      }
      // PUT ANY NEW FORECASTS TO SAVE OBJECT
      if (this.forecasts.length > 0) {
        variables.rows[0].forecasts = this.forecasts;
      }
      delete variables.rows[0].notify_df;


      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation orders_save($rows: [Order_input], $dateformat: String) {
              orders_save(rows: $rows, dateformat: $dateformat) {
                id
                value
                spent
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
        // if (response.data.orders_save.length > 0) {
        //   this.item = response.data.orders_save[0];

        //   if (parseFloat(this.item.spent) > 0 && parseFloat(this.item.value) > 0) {
        //     this.used = ((parseFloat(this.item.spent) / parseFloat(this.item.value)) * 100).toFixed(2)
        //   }
        // }

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;

      return;
    },

    forecasts_click(a, ss) {
      console.log("forecasts_toolClick", a, ss);
      switch (a) {
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "refresh":
          this.load();
          break;
        case "notes":
          this.forecasts.component = "OrdersForecastsNotes";
          break;
        case "discard":
          this.forecasts.component = null;
          break;
        case "delete":
          this.forecasts_delete(ss);
          break;
      }
    },

    forecasts_select(ss, tools) {
      console.log("forecasts_select", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "refresh", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.forecasts.selected = ss;
    },

    forecasts_update(ss) {
      console.log("forecasts_update", ss);
      this.item.forecasts = ss;
    },

    async forecasts_delete(ss) {
      console.log("forecasts_delete", ss);
      // PASS THE ID LIST TO DELETE MUTATION

      let variables = {
        rows: this.cleanit(ss),
      };
      console.log(variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation ordersforecasts_delete(
              $rows: [OrderForecast_input]
            ) {
              ordersforecasts_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },
  },
};
</script>

<style>
.card {
  text-align: left !important;
}
</style>